import api from "Common/Client/Interceptor";

export const fetchTrainingDetail = async (mentorId, token) => {
  try {
    const response = await api.get(
      `/TrainingGroup/Mentor/List?MentorId=${mentorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchReports = async (memberId, token) => {
  try {
    const response = await api.get(`/TrainingProgressReport/Learner/List?memberId=${memberId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching reports:', error)
    throw error
  }
}